/**
 * @typedef {Object} BusinessCardAppearance
 * @property {'wave'|'classic'|'modern'|'professional'|'gradient'} design
 * @property {string} waveStart   - Primary accent color (#RRGGBB)
 * @property {string} waveEnd     - Darker gradient companion (#RRGGBB)
 * @property {string} accentColor
 * @property {string} cardBg
 * @property {string} font        - One of FONT_OPTIONS
 */

export const DESIGN_OPTIONS = [
  { id: 'wave', label: 'Wave' },
  { id: 'classic', label: 'Classic' },
  { id: 'modern', label: 'Modern' },
  { id: 'professional', label: 'Professional' },
  { id: 'gradient', label: 'Gradient' },
];

export const FONT_OPTIONS = ['Inter', 'Roboto', 'Outfit', 'System UI', 'Georgia'];

const FONT_STACKS = {
  Inter: "'Inter', system-ui, sans-serif",
  Roboto: "'Roboto', system-ui, sans-serif",
  Outfit: "'Outfit', system-ui, sans-serif",
  'System UI': 'system-ui, -apple-system, Segoe UI, sans-serif',
  Georgia: "Georgia, 'Times New Roman', serif",
};

/** @type {BusinessCardAppearance} */
export const DEFAULT_APPEARANCE = {
  design: 'wave',
  waveStart: '#5B22BD',
  waveEnd: '#3B1580',
  accentColor: '#8B5CF6',
  cardBg: '#FFFFFF',
  font: 'Inter',
};

/**
 * @param {string} [font] - Font option name.
 * @returns {string} CSS font-family stack.
 */
export function fontStack(font) {
  return FONT_STACKS[font] || FONT_STACKS.Inter;
}

/**
 * Darkens a #RRGGBB color by a ratio (0–1). Used to derive the gradient end color
 * from the single picked accent color.
 * @param {string} hex
 * @param {number} [ratio=0.35]
 * @returns {string} Uppercase #RRGGBB.
 */
export function darken(hex, ratio = 0.35) {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex || '');
  if (!m) return DEFAULT_APPEARANCE.waveEnd;
  const n = parseInt(m[1], 16);
  const ch = (shift) => Math.max(0, Math.round(((n >> shift) & 255) * (1 - ratio)));
  return `#${[16, 8, 0].map((s) => ch(s).toString(16).padStart(2, '0')).join('')}`.toUpperCase();
}
